import {Card} from "../../../basic/card.tsx";
import {ShieldUser, UserPlus} from "lucide-react";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {VwpFeatureConfig} from "../../../../store/generated/api.ts";

interface AdditionalEntitlementCardsProps {
    config: VwpFeatureConfig | undefined;
}

export function AdditionalEntitlementCards({config}: AdditionalEntitlementCardsProps) {
    const {t} = useTranslationWithKeys();

    const hasEducationalQuotaCard = config?.educationalNewMembersPerPeriod != null;
    const hasAdminCapacityCard = config?.teamAdminCapacity != null;

    if (!hasEducationalQuotaCard && !hasAdminCapacityCard) {
        return null;
    }

    return (
        <div className="space-y-4">
            <h2 className="text-xl font-semibold">{t('dashboard.extraFeatures')}</h2>
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
                {hasEducationalQuotaCard && (
                    <Card className="p-6 shadow-sm border-border/50">
                        <div className="flex items-center justify-between mb-2">
                            <p className="text-muted-foreground">{t('dashboard.newMembersPerSemester')}</p>
                            <UserPlus className="h-5 w-5 text-primary"/>
                        </div>
                        <div className="flex items-baseline gap-2">
                            <span className="text-3xl">{config?.educationalNewMembersPerPeriod}</span>
                        </div>
                    </Card>
                )}
                {hasAdminCapacityCard && (
                    <Card className="p-6 shadow-sm border-border/50">
                        <div className="flex items-center justify-between mb-2">
                            <p className="text-muted-foreground">{t('dashboard.adminCapacity')}</p>
                            <ShieldUser className="h-5 w-5 text-primary"/>
                        </div>
                        <div className="flex items-baseline gap-2">
                            <span className="text-3xl">{config?.teamAdminCapacity}</span>
                        </div>
                    </Card>
                )}
            </div>
        </div>
    );
}
